import { EProductPublishScope } from '@gelato-api-ui/core/e-commerce/e-product-publish-scope.enum';

export const EProductPublishScopes = Object.values(EProductPublishScope);
